<section>
  <div class="container-fluid bg-lightgrey py-5">
    <h1 class="h3 text-center">Pubblicazioni</h1>
  </div>
  <div class="container-narrow py-5">
    <p>A partire dal 2018 la collaborazione tra ActionAid e openpolis ha dato vita a varie edizioni del rapporto Centri d'Italia.
Nel corso degli anni abbiamo tentato varie strade per accedere a dati il pi&ugrave; possibile coerenti e affidabili sui centri di accoglienza. Parallelamente quindi &egrave; cambiata anche la metodologia usata nei nostri rapporti. La pubblicazione del sito Centri d'Italia &egrave; il punto di arrivo di questo percorso. Da questo momento infatti i rapporti si baseranno sui dati liberamente accessibili su questa piattaforma. Allo stesso tempo per&ograve; speriamo che si tratti anche di un punto di partenza e che le informazioni oggi presenti siano in futuro arricchite con alcuni dati fondamentali ancora non disponibili.</p>
    <p>
      2025<br>
      <b>Centri d’Italia, accoglienza al collasso</b><br>
      Scarica il <a href="https://migrantidb.s3.eu-central-1.amazonaws.com/rapporti_pdf/centri_ditalia_accoglienza_al_collasso.pdf">rapporto</a>.<br>

    </p>
    <p>
      2024<br>
      <b>Centri d’Italia, un fallimento annunciato</b><br>
      Scarica il <a href="https://migrantidb.s3.eu-central-1.amazonaws.com/rapporti_pdf/centriditalia_un_fallimento_annunciato.pdf">rapporto</a>.<br>

    </p>
    <p>
      2023<br>
      <b>Centri d’Italia, il vuoto dell’accoglienza</b><br>
      Scarica il <a href="https://migrantidb.s3.eu-central-1.amazonaws.com/rapporti_pdf/centri_ditalia_il_vuoto_dellaccoglienza.pdf">rapporto</a>.<br>

    </p>
    <p>
      2022<br>
      <b>Centri d'Italia, l’emergenza che non c’è</b><br>
      Scarica il <a href="https://migrantidb.s3.eu-central-1.amazonaws.com/rapporti_pdf/centri_ditalia_lemergenzachenonce.pdf">rapporto</a>.<br>
      Vai all’<a href="https://www.canva.com/design/DAE9qGxktpc/6IEU2ok_kdvxS44jica-Tg/view?utm_content=DAE9qGxktpc&utm_campaign=designshare&utm_medium=link&utm_source=publishsharelink">infografica</a>.
    </p>
    <p>
      2021<br>
      <b>Centri d'Italia, una mappa dell'accoglienza</b><br>
      Leggi il rapporto <a href="https://www.openpolis.it/esercizi/limportanza-di-un-monitoraggio-dettagliato/">online</a> oppure scarica il <a href="https://www.openpolis.it/wp-content/uploads/2021/03/Centri-dItalia_Una-mappa-dellaccoglienza.pdf" download>pdf</a>.
    </p>
    <p>
     2020<br>
      <b>Centri d'Italia: il sistema a un bivio</b><br>
      Leggi il rapporto <a href="https://www.openpolis.it/esercizi/dallerrore-di-sistema-al-fallimento-i-contratti-dellaccoglienza/">online</a> oppure scarica il <a href="https://www.openpolis.it/wp-content/uploads/2020/10/centridItaliailsistemaaunbivio.pdf" download>pdf</a>.
    </p>
        <p>
     2019<br>
      <b>Centri d'Italia: la sicurezza dell'esclusione</b><br>
      Leggi il rapporto <a href="https://www.openpolis.it/esercizi/la-stretta-del-decreto-sicurezza-al-sistema-di-accoglienza/">online</a> oppure scarica il <a href="https://www.openpolis.it/wp-content/uploads/2020/02/CentridItalia_La-sicurezzadellEsclusione.pdf" download>pdf</a>.
    </p>
            <p>
     2018<br>
      <b>Centri d'Italia</b><br>
      Leggi il rapporto <a href="https://www.openpolis.it/esercizi/i-centri-di-accoglienza-in-italia-la-spesa-e-i-contratti-pubblici/">online</a> oppure scarica il <a href="https://www.openpolis.it/wp-content/uploads/2018/11/Centri-dItalia-2018.pdf" download>pdf</a>.
    </p>
  </div>
</section>
